export default {
  featureFlags: {
    switchUserLanguage: true,
    performanceMetrics: false,
  },
}
